import { createClient } from '@supabase/supabase-js';
import { cookieStorage } from './cookie-storage';

const url     = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    '[Diwan] Missing Supabase config — VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set. ' +
    'In local dev: add them to client/.env. In Vercel: Settings → Environment Variables. ' +
    'The VITE_ prefix is required so Vite includes them in the client bundle.'
  );
}

// One-time migration: move any existing localStorage session into cookie storage
// so users are not logged out when first hitting this build.
try {
  const AUTH_KEY = 'diwan-auth';
  const existing = localStorage.getItem(AUTH_KEY);
  if (existing && !cookieStorage.getItem(AUTH_KEY)) {
    cookieStorage.setItem(AUTH_KEY, existing);
  }
  // Always clean up localStorage copy so the cookie becomes authoritative.
  if (existing) localStorage.removeItem(AUTH_KEY);
} catch { /* storage blocked — ignore */ }

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession:     true,
    autoRefreshToken:   true,
    storageKey:         'diwan-auth',
    detectSessionInUrl: true,
    storage:            cookieStorage,
  },
});

// Supabase auto-processes the PKCE code in the URL during createClient(), which fires
// PASSWORD_RECOVERY before any React component has mounted. We capture it here — the
// earliest possible point — so AuthCallback can read it reliably from sessionStorage.
supabase.auth.onAuthStateChange((event) => {
  if (event === 'PASSWORD_RECOVERY') {
    sessionStorage.setItem('diwan_recovery_pending', 'true');
  }
});
